import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useFetchProducts from '../../hooks/useFetchProducts';
import ProductCard from '../../components/Card/ProductCard';
import {Breadcrumb, message, Skeleton} from 'antd';

const ProductsPage = () => {
    const { category, subcategory1, subcategory2 } = useParams();
    const { products, loading, error } = useFetchProducts();

    const [filteredProducts, setFilteredProducts] = useState([]);

    useEffect(() => {
        const filtered = products.filter(product => {
            const isCategoryMatch = product.category === category;
            const isSubCategory1Match = subcategory1 ? product.subcategory === subcategory1 : true;
            const isSubCategory2Match = subcategory2 ? product.subcategory2 === subcategory2 : true;
            return isCategoryMatch && isSubCategory1Match && isSubCategory2Match;
        });
        setFilteredProducts(filtered);
    }, [category, subcategory1, subcategory2, products]);

    if (loading) return <></>;
    if (error) return message.error(error.message);

    const breadcrumbItems = [
        { title: 'Главная', href: '/' },
        { title: category, href: `/products/${category}` },
        subcategory1 && { title: subcategory1, href: `/products/${category}/${subcategory1}` },
        subcategory2 && { title: subcategory2, href: `/products/${category}/${subcategory1}/${subcategory2}` }
    ].filter(Boolean);

    return (
        <div className="p-4">
            <div className="mb-10">
                <Breadcrumb>
                    {breadcrumbItems.map((item, index) => (
                        <Breadcrumb.Item key={index}>
                            {item.href ? <a href={item.href}>{item.title}</a> : item.title}
                        </Breadcrumb.Item>
                    ))}
                </Breadcrumb>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                {filteredProducts.length > 0 ? (
                    filteredProducts.map(product => (
                        <ProductCard key={product.id} product={product} />
                    ))
                ) : (
                    <Skeleton active/>
                )}
            </div>
        </div>
    );
};

export default ProductsPage;